import React from 'react';

import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { MainImageHeader } from '@/pages/Paywall/components/MainImageHeader';

import {
  MainImageStyles,
  MainImageTextContainerStyles,
  MainImageContentStyles,
  MainImageTitleStyles,
} from './MainImage.styles';

export const SectionMainImage: React.FC = () => {
  return (
    <MainImageStyles>
      <MainImageContentStyles>
        <MainImageHeader />
        <MainImageTextContainerStyles>
          <MainImageTitleStyles>
            You’re Hardly Ready…
            <br />
            <MainImageTitleStyles>Unlock the Rest</MainImageTitleStyles>
          </MainImageTitleStyles>
          <OnboardingSubtitle color={'neutral-white'}>
            Endless stories. Zero limits. All shaped by your deepest desires.
          </OnboardingSubtitle>
        </MainImageTextContainerStyles>
      </MainImageContentStyles>
    </MainImageStyles>
  );
};
